var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.533 16.5888L10.3211 18.6442C10.0504 18.8966 9.60976 18.6893 9.63472 18.3197C9.70384 17.2752 9.81136 15.6883 9.88336 14.8061C9.89488 14.6669 10.012 14.5114 10.1234 14.4106C12.7067 12.0682 15.2959 9.73153 17.884 7.39298C17.98 7.30658 18.0933 7.09346 18.0338 6.98114C17.9666 6.85442 17.6565 6.89282 17.5279 6.97346C14.2408 9.04322 10.9538 11.112 7.67152 13.1885C7.46992 13.3152 7.2232 13.3459 6.99664 13.273C5.64303 12.8381 4.28175 12.4262 2.92527 11.9981C2.61327 11.8992 2.24271 11.8013 2.20719 11.4144C2.16975 11.0103 2.51631 10.8182 2.82928 10.6925C4.09072 10.1837 5.3608 9.69697 6.62896 9.20738C11.1909 7.44962 15.7528 5.69282 20.3147 3.93602C20.4674 3.87746 20.6709 3.84098 20.8303 3.8093C21.3083 3.7133 21.7384 3.9533 21.7855 4.43714C21.821 4.79138 21.7586 5.18594 21.6847 5.53634C20.7343 10.057 19.7714 14.5757 18.8095 19.0954C18.5503 20.3165 17.9224 20.5478 16.9115 19.8019C15.6088 18.84 12.533 16.5888 12.533 16.5888Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.d3babfe5100c047a14bc4ccfcb0b30a3.svg";
export { ForwardRef as ReactComponent };